import React, { ReactNode } from 'react'
import Link from 'components/Link'
import styled from 'styled-components'

import { isNonProductionBuild } from 'utils/environment'

interface VersionItemLinkProps {
  className?: string
  isDisabled?: boolean
  to?: string
  children: ReactNode
}

const UnstyledVersionItemLink = ({
  isDisabled,
  to,
  ...rest
}: VersionItemLinkProps) => {
  if (isDisabled) {
    return <span {...rest} />
  }
  if (!to) {
    if (isNonProductionBuild()) {
      throw new Error(
        `URL Pathname expected, however, ${JSON.stringify(to)} received`
      )
    }
    return <span {...rest} />
  }
  return <Link {...rest} to={to} />
}

export const VersionItemLink = styled(UnstyledVersionItemLink)`
  display: flex;
  align-items: center;
  width: 100%;
  flex: 1;
  overflow: hidden;
`
